import React from 'react';

export default function ReadMore() {
    return (
        <div className="modal fade" id="ReadMore" tabIndex={-1} aria-labelledby="exampleModalLabel">
            <div className="modal-dialog performance-popup">
                <div className="modal-content">
                    <div className="modal-header px-5">
                        <h5 className="modal-title font-24 bold-text text-blue" id="exampleModalLabel">
                            Performance Evaluation
                        </h5>
                        <a data-bs-dismiss="modal" className="text-decoration-none">
                            <img src="/Images/close-icon.svg" />
                        </a>
                    </div>
                    <div className="modal-body px-5">
                        <h6 className="semibold-text mt-4 font-20 text-blue">Do you know about our evaluation ?</h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                When you are working in an organization, it is important to understand where you are, what you know, and
                                what the next steps are. To grow in our career and to add more value to our work, it is necessary to get
                                feedback.
                            </li>
                        </ul>
                        <h6 className="semibold-text mt-4 font-20 text-blue">When and how often is this done?</h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                We have this evaluation once in three months, four times a year. Your work will be evaluated based on the
                                goals you set and the expectations that are conveyed by your Leads every quarter.
                            </li>
                        </ul>
                        <h6 className="semibold-text mt-4 font-20 text-blue">Who will set the goals? </h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                At the beginning of every quarter, you along with your Lead will decide the goals. You will be fully aware
                                of the goals that you need to achieve for the quarter. The goals can be for skill development on a personal
                                level or it can also be the project completion put across as a Team goal.
                            </li>
                        </ul>
                        <h6 className="semibold-text mt-4 font-20 text-blue">How will the goals be evaluated? </h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                The objectives set by you and your Lead, the performance, key results, and the progress will be taken into
                                consideration. However, they will be evaluated based on the pyramid principles that we follow in our
                                organization.
                            </li>
                        </ul>
                        <h6 className="semibold-text mt-4 font-20 text-blue">What are the pyramid principles?</h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                With our years of experience in terms of dealing with people and tech, we have designed the principles that
                                work best. We follow these principles and the foundation of our organization stands on that. Whether it is
                                about the work environment or handling clients, we strongly believe in them and follow them no matter what.
                            </li>
                        </ul>
                        <div className="text-center my-3">
                            <img src="/Images/performance-evaluation-chart.svg" />
                        </div>
                        <h6 className="semibold-text mt-4 font-20 text-blue">Attitude</h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                Your attitude matters a lot to us. The complete process of evaluation is to help you explore and tap into
                                your fullest potential through feedback. However, taking the feedback positively, and getting that reflected
                                in your work is also very important.{' '}
                            </li>
                            <li className="my-2">
                                Treating everyone equal is a principle that we follow strictly. No matter whether you are a fresher, or an
                                experienced, we are all treated the same and we need to treat everyone equally.{' '}
                            </li>
                            <li className="my-2">
                                Take time to understand things. Collect as many details as you can before starting the work. Whether it is a
                                process or a theory, do not act without understanding.
                            </li>
                            <li className="my-2">
                                ASK! Ask when you don't understand something. Raise questions when you want to understand something better.
                                Ask when you are doubtful about something. Ask when you require more clarification.{' '}
                            </li>
                            <li className="my-2">
                                We do not compete with each other. When you know something, teach others. When you do not know something,
                                learn from others. Helping each other is everything here!
                            </li>
                            <li className="my-2">Express your thoughts clearly. Keep communication straight and clear with everyone.</li>
                        </ul>
                        <h6 className="semibold-text mt-4 font-20 text-blue">Communication</h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                Your language is important but what is more important is the way you express your thoughts and opinions. You
                                have to deal with the person concerned at the given time and express clearly what you can do, and what you
                                cannot do. Also, you are expected to mention the help you would require to get the particular work done.
                            </li>
                        </ul>
                        <h6 className="semibold-text mt-4 font-20 text-blue">Business</h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                Take time to understand what is done, what is being solved, and how it is done. If you were to work in a
                                particular domain, understanding the business is very crucial. Without understanding the business, you
                                cannot proceed with the work. To develop solutions, you should be able to explain the businesses first as
                                simple as you would explain them to a five-year-old.
                            </li>
                        </ul>
                        <h6 className="semibold-text mt-4 font-20 text-blue">Technology</h6>
                        <ul className="list-unstyled font-12 medium-text performance-popup-para">
                            <li className="my-2">
                                With our proprietary software delivery process called ‘Vetri', we use the 4D concept for this evaluation.
                            </li>
                            <li className="my-2">Define -&gt; Design-&gt; Develop-&gt; Deploy </li>
                            <li className="my-2">
                                The evaluation of the technology is done based on how well you are able to define it, use the definition for
                                designing, developing a model out of your design, and finally, deploying it successfully. The minute details
                                kept in mind while converting the definition to design and then developing it will be considered for
                                evaluation.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
